import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const DateRange = ({ dateRange, format }) => {
  let formattedDateRange;

  if (dateRange.max > dateRange.min) {
    // need to see how they get formatted
    const formattedMinDate = moment.utc(dateRange.min).format(format);
    const formattedMaxDate = moment.utc(dateRange.max).format(format);

    if (formattedMinDate === formattedMaxDate) {
      formattedDateRange = formattedMaxDate;
    } else {
      formattedDateRange = `${formattedMinDate} - ${formattedMaxDate}`;
    }
  } else {
    // the two dates were exactly equal or min was greater than max, just show the max
    formattedDateRange = moment.utc(dateRange.max).format(format);
  }

  return (
    <span>{formattedDateRange}</span>
  );
};

DateRange.defaultProps = {
  format: 'MMM D'
};

DateRange.propTypes = {
  dateRange: PropTypes.shape({
    min: PropTypes.date,
    max: PropTypes.date
  }),
  format: PropTypes.string
};

export default DateRange;



/** WEBPACK FOOTER **
 ** ./src/components/product/DateRange.jsx
 **/